export default __webpack_public_path__ + "static/media/thumbnail-2.3f3ecb1d.png";